import { Alert, AlertTitle } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";

const SemanaSoloLecturaBanner = ({ esPasada }) => {
  return (
    <Alert
      severity="info"
      icon={<HistoryToggleOffIcon fontSize="inherit" />}
      sx={{ borderRadius: 3, mb: 2, fontWeight: 500 }}
    >
      <AlertTitle sx={{ fontWeight: 700 }}>
        {esPasada ? "Semana pasada" : "Esta semana ya no se puede modificar"}
      </AlertTitle>
      {esPasada
        ? "Solo podés consultar qué elegiste. Para pedir tu vianda, andá a la semana que viene."
        : "Las viandas de la semana en curso ya quedaron confirmadas. Para elegir o cambiar tu vianda, andá a la semana que viene."}
    </Alert>
  );
};

export default SemanaSoloLecturaBanner;
